import { useEffect, useState } from "react"
import { FaUpload } from "react-icons/fa6";
import { Box, Center, HStack, Icon, Spinner, Stack, VStack } from "@chakra-ui/react"
import { Button, Text } from "@/components"
import { DropZone } from "./DropZone"

interface Props {
  uploadDocuments: (filesToUpload: File[]) => void
  isLoading: boolean
  isSuccess: boolean
}

export const DropZoneContainer = ({ uploadDocuments, isLoading, isSuccess }: Props) => {
  const [filesToUpload, setFilesToUpload] = useState<File[]>([])
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setFilesToUpload([]);
    }
  }, [isSuccess])

  const handleFilesDrop = (files: File[]) => {
    setFilesToUpload(prevFiles => [...prevFiles, ...files])
  }

  const handleFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const newFiles = Array.from(e.target.files);
    setFilesToUpload((prev) => [...prev, ...newFiles]); // add files
    e.target.value = "";
  }

  return (
    <DropZone onDragStateChange={setIsDragging} onFilesDrop={handleFilesDrop}>
      <VStack pt={10} pb={10}>
        <Icon as={FaUpload as React.ElementType} boxSize={10} color="text.primary" />
        <Box className="file-upload-container" mt={5} mb={5}>
          <label className="file-upload-label">
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
              className="file-upload-input"
              onChange={handleFilesChange}
              multiple
            />
            Choose a file
          </label>
        </Box>
        { filesToUpload.length === 0 ? (
          <Text fontSize="sm">No files to upload</Text>
        ) : (
          <Text>Files to upload: {filesToUpload.length}</Text>
        )}

        {/* Render the file list */}
        <Stack pt={5}>
          {
            filesToUpload.map((file, index) => (
              <Text key={index}>{file.name}</Text>
            ))
          }
        </Stack>
        {
          filesToUpload.length > 0 && (
            <HStack pt={5}>
              <Button variant="solid" onClick={() => uploadDocuments(filesToUpload)}>Upload</Button>
              <Button variant="outline" onClick={() => setFilesToUpload([])}>Clear</Button>
            </HStack>
          )
        }
        {
          isLoading && (
            <Center><Spinner /></Center>
          )
        }
      </VStack>
    </DropZone>
  )
}